export function clientPointToImagePixel(
  clientX: number,
  clientY: number,
  displayRect: { left: number; top: number; width: number; height: number },
  imageWidth: number,
  imageHeight: number,
): { x: number; y: number } | null {
  if (displayRect.width <= 0 || displayRect.height <= 0 || imageWidth <= 0 || imageHeight <= 0) {
    return null;
  }
  const x = ((clientX - displayRect.left) / displayRect.width) * imageWidth;
  const y = ((clientY - displayRect.top) / displayRect.height) * imageHeight;
  if (x < 0 || y < 0 || x > imageWidth || y > imageHeight) {
    return null;
  }
  return { x, y };
}
